<template>
  <div class="wrapper">
    <overlay :show="!loadingAll" rounded="sm">
      <Header :validade="validade" :vencida="vencida" />
      <div class="content-wrapper" :class="{ 'ml-0': source == 'iframe' }">
        <div class="row">
          <div class="col-sm-12">
            <div class="card card-cabecalho">
              <div class="card-header">
                <b-row>

                  <b-col cols="5" class="text-length p-0 d-none d-md-block">
                    <a href="#" class="btn btn-success btn-sm">
                      <span class="no-label">Cód. Cotação: </span>
                      <span class="label">Cód.: </span>
                      <span>{{ cotacaoId }} </span>
                    </a>
                  </b-col>
                  <b-col cols="2" md="7" class="text-right p-0 d-none d-md-block">
                    <b-button-group class="mr-1" v-if="!vencida">
                      <b-button @click="modalOpen('impressao')" title="Imprimir" size="sm" class="imprimir">
                        <b-spinner small variant="success" v-if="!loadingSession"
                          title="Aguarde o carregamento dos dados"></b-spinner>
                        <b-icon icon="printer" aria-hidden="true" v-if="loadingSession"></b-icon>
                        Imprimir
                      </b-button>
                    </b-button-group>
                  </b-col>

                  <!-- visualização no mobile -->
                  <b-col cols="12" class="p-0 mb-2 d-md-none">
                    <a href="#" class="btn btn-success btn-sm w-100">
                      <span class="no-label">Cód. Cotação: </span>
                      <span class="label">Cód.: </span>
                      <span>{{ cotacaoId }} </span>
                    </a>
                  </b-col>

                  <b-col cols="12" class="d-flex justify-content-between p-0">
                    <a href="#" class="btn btn-warning btn-sm mb-2 d-md-none" v-if="vencida">
                      <span>Status: Vencida</span>
                    </a>
                    <a href="#" class="btn btn-success btn-sm mb-2 d-md-none" v-else-if="validade">
                      <span class="no-label">Valido Até: </span>
                      <span>{{ validade | data }}</span>
                    </a>

                    <b-button-group class="mr-1 d-md-none" v-if="!vencida">
                      <b-button @click="modalOpen('impressao')" title="Imprimir" size="sm">
                        <b-spinner small variant="success" v-if="!loadingSession"
                          title="Aguarde o carregamento dos dados"></b-spinner>
                        <b-icon icon="printer" aria-hidden="true" v-if="loadingSession"></b-icon>
                        Imprimir
                      </b-button>
                    </b-button-group>
                  </b-col>

                </b-row>

              </div>
              <div class="card-body table-responsive">
                <table class="table" v-if="!vencida">
                  <tbody>
                    <tr>
                      <td>
                        <table class="table p-0 m-0" width="100%" align="right" border="0" cellspacing="0"
                          cellpadding="0">
                          <tbody>
                            <tr>
                              <td style="text-align: left;">
                                <p>
                                  <font color="#666666" size="2" face="Arial, Helvetica, sans-serif">
                                    Para
                                    <font color="#007CC3"><strong>{{ cliente_nome }}</strong></font><br />
                                    <span v-if="cliente_email">
                                      E-mail:
                                      <strong>
                                        <font color="#007CC3">{{
                                          cliente_email
                                        }}</font>
                                      </strong><br /></span>
                                    De:
                                    <strong>
                                      <font color="#007CC3">{{ user.name }} (<a :href="`mailto:${user.email}`">
                                          <font color="#75CDFF">{{
                                            user.email
                                          }}</font>
                                        </a>)</font>
                                    </strong><br />
                                    <br />
                                    {{ cotacaoUf }}, {{ cotacaoData | dataLong
                                    }}<br />
                                    <br />
                                    Prezado(a) {{ cliente_nome }},
                                  </font>
                                </p>
                                <div id="comentario" style="background-color:#F1F1F1;padding:10px;">
                                  <font color="#666666" size="2" face="Arial, Helvetica, sans-serif"
                                    :inner-html.prop="cotacaoMensagem"></font>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr v-if="cotacaoArquivos && cotacaoArquivos.length">
                      <td height="20" align="center">
                        <table class="table p-0 m-0" width="100%" align="center" border="0" cellspacing="0"
                          cellpadding="0">
                          <tbody>
                            <tr>
                              <td valign="top">
                                <font color="#666666" size="2" face="Arial, Helvetica, sans-serif">
                                  Arquivos anexados:
                                </font>
                              </td>
                            </tr>
                            <tr>
                              <td valign="top">
                                <template v-for="arquivo in cotacaoArquivos">
                                  <span class="preview mr-3" :key="arquivo.id">
                                    <b-icon icon="file-earmark-arrow-down" aria-hidden="true" v-if="loadingSession"
                                      font-scale="2"></b-icon>
                                    <a :href="arquivo.visualizar" class="ml-2"
                                      style="color:#333;font-size:12px;text-decoration: underline;" target="_blank"
                                      :title="`Clique aqui para baixar o arquivo ${arquivo.nome}`
                                        ">
                                      {{ arquivo.nome }}
                                    </a>
                                  </span>
                                </template>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <table class="table p-0 m-0" width="95%" align="center" border="0" cellspacing="0"
                          cellpadding="0">
                          <tbody>
                            <tr>
                              <td style="text-align: left;">
                                <font color="#666666" size="2" face="Arial, Helvetica, sans-serif">Segue Abaixo:</font>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <h3 class="text-center" v-else>Cotação vencida!</h3>
              </div>
            </div>
          </div>

          <div class="ViewModeButtons">
            <div class="buttonsContainer">

              <div>
                <button
                  :class="{ 'leftButtonActive': PlansViewMode === 'porPlano', 'leftButton': PlansViewMode !== 'porPlano' }"
                  @click="ChangeViewToCard()">
                  <font-awesome-icon :icon="['fa', 'grip-horizontal']"
                    :style="{ color: PlansViewMode === 'porPlano' ? '#41b883' : '#fff' }" /> Planos
                </button>

                <button
                  :class="{ 'leftButtonActive': PlansViewMode === 'tabela', 'leftButton': PlansViewMode !== 'tabela' }"
                  @click="ChangeViewToTable()">
                  <font-awesome-icon :icon="['fa', 'grip-lines-vertical']" size="sm"
                    :style="{ color: PlansViewMode === 'tabela' ? '#41b883' : '#fff', verticalAlign: '0' }" /> Comparativo
                </button>
              </div>

            </div>

            <div class="buttonsContainer">

              <div>
                <button
                  :class="{ 'rightButtonActive': IsResponsive === 'mobile', 'rightButton': IsResponsive !== 'mobile' }"
                  @click="ChangeIsResponsiveToTrue()">
                  <font-awesome-icon :icon="['fa', 'mobile']" />
                </button>
                <button
                  :class="{ 'rightButtonActive': IsResponsive === 'desktop', 'rightButton': IsResponsive !== 'desktop' }"
                  @click="ChangeIsResponsiveToFalse()">
                  <font-awesome-icon :icon="['fas', 'desktop']" />
                </button>
              </div>

            </div>
          </div>

          <section class="card PlanCards" v-if="PlansViewMode == 'porPlano'">

            <div class="FilterButtons d-none d-md-block" v-if="this.Plans.length >= 6">

              <select @change="ChangeSortByFilter($event)" name="SortBy" id="select">
                <option value="" selected>Ordenar por </option>
                <option value="highest">Maior valor</option>
                <option value="lowest">Menor valor</option>
                <option value="alphabetic">Ordem alfabética</option>
              </select>

              <select @change="ChangeLodgingFilter($event)" name="Lodging" id="select">
                <option value="">Acomodação </option>
                <option value="Enfermaria">Enfermaria</option>
                <option value="Apartamento">Apartamento</option>
              </select>

              <select @change="ChangeCoverageFilter($event)" name="Coverage" id="select">
                <option value="">Abrangência</option>
                <option value="Nacional">Nacional</option>
                <option value="Estadual">Estadual</option>
                <option value="Regional">Regional</option>
                <option value="Local">Local</option>
              </select>

              <select @change="ChangeCoparticipationFilter($event)" name="Co-participation" id="select">
                <option value="" selected>Coparticipação</option>
                <option value="sim">Sim</option>
                <option value="nao">Não</option>
              </select>
            </div>

            <main>
              <div class="GroupSelection" v-if="this.cenarios.length > 1">
                <button :class="SelectedGroup == cenario.nome ? 'GroupButtonActive' : 'GroupButtonDeactive'"
                  :key="`linha-cenario-${index}`" v-for="(cenario, index) in cenarios"
                  @click="[ChangeGroupFilter(cenario.nome), cleanComparative()]">{{cenario.nome }}</button>
              </div>

              <section class="CardsContainer">

                <PlanCard v-for="(plano, index) in filteredPlanList" :key="plano.calculo.total_iof"
                  :IsChecked="plano.checked" @compare-feature="CompareSelection(plano, index)"
                  :Titulares="plano.titulares" :TotalHospitals="totalHospitais(plano, plano.cenarioRegioes)"
                  :TotalLaboratories="totalLaboratorios(plano, plano.cenarioRegioes)"
                  :dataToDeleteOrEdit="{ plano: plano }" :planColor="plano.operadora.cor"
                  :maisInformacoes="maisInformacoes" :Cenario="plano.cenario" :Plano="plano" :whatsapp="clientWhatsapp"
                  @checkbox-change="handleCheckboxChange(plano, index)"
                  :ShowRecomendar="showRecomendar(plano.cenario, plano)" />
                <ModalTabela />
              </section>

            </main>
          </section>

          <section class="col-12" v-if="PlansViewMode == 'tabela'">

            <div v-if="!vencida">
              <card v-if="exibirCenarios">
                <div ref="body" class="cenario mb-2">
                  <button class="scroll-button float-left" @click="sideScroll('left')" v-if="showLeftArrow">
                    <b-icon icon="caret-left-fill"></b-icon>
                  </button>
                  <button icon="caret-right-fill" class="scroll-button float-right" @click="sideScroll('right')"
                    v-if="showRightArrow">
                    <b-icon icon="caret-right-fill"></b-icon>
                  </button>
                  <table id="table-group" ref="bodyOverflow" class="table table-sm" :class="'overflowing-' + overflow"
                    :style="[baseStyles]">
                    <template v-for="(cenario, index) in isComparative">

                      <thead :key="`linha-cabecalho-${index}`">
                        <tr>
                          <th class="eixo white"></th>
                          <th class="operadora white" :colspan="parsePlanos(operadora.grupos).length"
                            v-for="(operadora, indexo) in cenario.operadoras" :key="`logo-operadora-${index}-${operadora.id}-${indexo}`
                              ">
                            <div class="logo" :style="`border-color: ${operadora.cor
                              ? '#' + operadora.cor.replace('#', '')
                              : 'grey'
                              };`
                              ">
                              <img :src="operadora.logotipoavo" :alt="operadora.nome" :title="operadora.nome" />
                            </div>
                          </th>
                        </tr>
                        <tr class="alternate">
                          <th class="eixo">
                            <div class="row text-left ml-2 no-gutters align-center justify-center">
                              <div class="col">
                                <span class="grupo" :data-id="cenario.id">{{
                                  cenario.nome
                                }}</span>
                                <br />
                                <small>{{ vidas(cenario) }} vidas</small>
                              </div>
                            </div>
                          </th>
                          <template v-for="(operadora, indexo) in cenario.operadoras">
                            <th class="text-center" v-for="(plano, indexp) in parsePlanos(
                              operadora.grupos
                            )" :key="`coluna-operadora-${index}-${plano.id}-${indexo}-${indexp}`">
                              <div class="plano-area">
                                <div class="mb-n1" style="font-size: 12px" v-if="plano.admin_nome && plano.entidade_nome">
                                  {{ plano.admin_nome ? plano.admin_nome : "" }} -
                                  {{
                                    plano.entidade_nome ? plano.entidade_nome : ""
                                  }}
                                </div>
                                <div class="mb-n1" style="font-size: 12px">
                                  {{ plano.produto.nome }}
                                </div>
                                <div class="mw80">
                                  <span style="
                                    font-size: 0.7rem !important;
                                    font-weight: 600;
                                    line-height: 1.75;
                                    opacity: 1;
                                    filter: alpha(opacity=100);
                                    transition: all 150ms linear;
                                  ">
                                    <div v-html="plano.nome" style="display: inline-block;"></div><br />
                                  </span>
                                  <template v-if="plano.alertas && plano.alertas.length > 0">
                                    <b-icon icon="info-circle-fill" variant="warning"></b-icon>
                                    <span style="font-size: 10px; font-weight: bold; text-transform: uppercase;">
                                      {{ plano.alertas.join('') }}
                                    </span>
                                  </template>
                                </div>
                                <div class="actions"></div>
                              </div>
                            </th>
                          </template>
                        </tr>
                      </thead>
                      <tbody :key="`linha-recomendar-${index}`" v-if="showRows('recomendar') && hasRecomendar()">
                        <transition name="fade">
                          <tr>
                            <td>Recomendar</td>
                            <template v-for="operadora in cenario.operadoras">
                              <b-td v-for="(plano, indexp) in parsePlanos(
                                operadora.grupos
                              )" :key="`recomendar-${plano.id}-${indexp}`" role="cell" class="text-center">
                                <div style="
                                  max-width: 200px;
                                  height: 100%;
                                  font-size: 10px;
                                  padding: 5px;
                                  text-align: center;
                                  background-color: transparent;
                                  margin: 0 auto;
                                " v-if="showRecomendar(cenario, plano)" :id="`textarea-recomendar-${cenario.id}-${plano.id}`
                                  ">
                                  {{ plano.recomendar }}
                                </div>
                                <div v-else>-</div>
                              </b-td>
                            </template>
                          </tr>
                        </transition>
                      </tbody>
                      <tbody :key="`linha-atuacao-${index}`" v-if="showRows('atuacao')">
                        <tr class="alternate">
                          <td class="p-2">Atuação</td>
                          <template v-for="(operadora, indexo) in cenario.operadoras">
                            <b-td class="text-center p-2" v-for="(plano, indexp) in parsePlanos(
                              operadora.grupos
                            )" :key="`atuacao-${index}-${indexo}-${plano.id}-${indexp}`">
                              <span>{{ plano.atuacao }}</span>
                            </b-td>
                          </template>
                        </tr>
                      </tbody>
                      <tbody :key="`linha-modalidade-${index}`" v-if="showRows('modalidade')">
                        <tr>
                          <td class="p-2">Modalidade</td>
                          <template v-for="(operadora, indexo) in cenario.operadoras">
                            <b-td class="text-center p-2" v-for="(plano, indexp) in parsePlanos(
                              operadora.grupos
                            )" :key="`modalidade-${index}-${indexo}-${plano.id}-${indexp}`">
                              <span>{{ plano.modalidade }}</span>
                            </b-td>
                          </template>
                        </tr>
                      </tbody>
                      <tbody :key="`linha-acomodacao-${index}`" v-if="showRows('acomodacao')">
                        <tr class="alternate">
                          <td class="p-2">Acomodação</td>
                          <template v-for="(operadora, indexo) in cenario.operadoras">
                            <b-td class="text-center p-2" v-for="(plano, indexp) in parsePlanos(
                                operadora.grupos
                              )" :key="`acomodacao-${index}-${indexo}-${plano.id}-${indexp}`">
                              <span>{{
                                plano.acomodacao ? plano.acomodacao : "Não"
                              }}</span>
                            </b-td>
                          </template>
                        </tr>
                      </tbody>
                      <tbody :key="`linha-coparticipacao-${index}`" v-if="showRows('coparticipacao')">
                        <tr>
                          <td class="p-2">Coparticipação</td>
                          <template v-for="(operadora, indexo) in cenario.operadoras">
                            <b-td class="text-center p-2" v-for="(plano, indexp) in parsePlanos(
                              operadora.grupos
                            )" :key="`coparticipacao-${index}-${indexo}-${plano.id}-${indexp}`">
                              <span v-if="plano.coparticipacao_porcentagem != ''">
                                {{ plano.coparticipacao == '1' ? "Sim" : "Não" }}
                              </span>
                              <span v-else variant="link" class="shadow-none" v-b-popover.hover="plano.coparticipacao_porcentagem
                                " title="">
                                {{ plano.coparticipacao == '1' ? "Sim" : "Não" }}
                              </span>
                            </b-td>
                          </template>
                        </tr>
                      </tbody>
                      <tbody :key="`linha-reembolso-${index}`" v-if="showRows('reembolso')">
                        <tr class="alternate">
                          <td class="p-2">Reembolso</td>
                          <template v-for="(operadora, indexo) in cenario.operadoras">
                            <b-td class="text-center p-2" v-for="(plano, indexp) in parsePlanos(
                              operadora.grupos
                            )" :key="`reembolso-${index}-${indexo}-${plano.id}-${indexp}`">
                              <span v-if="plano.reembolso != ''">
                                {{ plano.reembolso == '1' ? "Sim" : "Não" }}
                              </span>
                              <span v-else class="underline" @click="modalReembolso(cenario, operadora, plano)">
                                {{ plano.reembolso == '1' ? "Sim" : "Não" }}
                                <b-icon icon="search" variant="danger" />
                              </span>
                            </b-td>
                          </template>
                        </tr>
                      </tbody>
                      <tbody :key="`linha-taxas-${index}`" v-if="showRows('taxas-iof')">
                        <tr>
                          <td class="p-2">Taxas/IOF</td>
                          <template v-for="(operadora, indexo) in cenario.operadoras">
                            <b-td class="text-center p-2" v-for="(plano, indexp) in parsePlanos(
                              operadora.grupos
                            )" :key="`iof-${index}-${indexo}-${plano.id}-${indexp}`">
                              <span v-if="!plano.taxas.descricao">
                                {{ plano.taxas.iof ? "Sim" : "Não" }}
                              </span>
                              <span v-else class="underline" @click="modalReembolso(cenario, operadora, plano)"
                                variant="link" v-b-popover.hover="plano.taxas.descricao" title="">
                                <font-awesome-icon :icon="['fas', 'search-dollar']" />
                                {{ plano.taxas.iof ? "Sim" : "Não" }}
                              </span>
                            </b-td>
                          </template>
                        </tr>
                      </tbody>
                      <tbody :key="`linha-mei-${index}`" v-if="showRows('mei')">
                        <tr>
                          <td class="p-2">Aceita MEI</td>
                          <template v-for="(operadora, indexo) in cenario.operadoras">
                            <b-td class="text-center p-2" v-for="(plano, indexp) in parsePlanos(
                              operadora.grupos
                            )" :key="`mei-${index}-${indexo}-${plano.id}-${indexp}`">
                              <span>
                                {{ plano.mei ? "Sim" : "Não" }}
                              </span>
                            </b-td>
                          </template>
                        </tr>
                      </tbody>
                      <tbody :key="`linha-informacao-${index}`" v-if="showRows('informacoes')">
                        <tr class="alternate">
                          <td>Informações</td>
                          <template v-for="(operadora, indexo) in cenario.operadoras">
                            <b-td class="text-center" v-for="(plano, indexp) in parsePlanos(
                              operadora.grupos
                            )" :key="`informacoes-${index}-${indexo}-${plano.id}-${indexp}`">
                              <small class="pointer primary--text mais-informacoes" @click="
                                maisInformacoes(cenario, operadora, plano)
                                ">
                                + informações
                              </small>
                            </b-td>
                          </template>
                        </tr>
                      </tbody>

                      <tbody :key="`linha-redes-${index}`" class="mw80 ma-4 pa-4" v-if="showRows('hospitais')">
                        <tr class="header">
                          <td class="px-0">
                            <div class="row text-left ml-0 no-gutters align-center justify-center"
                              v-on:click="showHospitais = !showHospitais">
                              <div class="col">
                                <span class="d-block pt-1">
                                  Hospitais
                                  <b-icon icon="caret-down-fill" style="
                                  float: right;
                                  margin-top: 3px;
                                  margin-right: 13px;
                                  font-size: 14px;
                                  color: #212529;
                                "></b-icon>
                                </span>
                              </div>
                            </div>
                          </td>
                          <template v-for="operadora in cenario.operadoras">
                            <td class="text-center rede-sumario p-2" v-for="plano in parsePlanos(operadora.grupos)"
                              :key="plano.id">
                              <small v-if="plano.filtros.tipo_plano != 'o'">{{
                                totalHospitais(plano, cenario.regioes)
                              }}
                                Hospitais</small>
                              <small v-if="plano.filtros.tipo_plano != 'o'">{{
                                totalCentros(plano, cenario.regioes)
                              }}
                                Centros</small>
                              <small v-if="plano.filtros.tipo_plano != 'o'">{{
                                totalLaboratorios(plano, cenario.regioes)
                              }}
                                Laboratórios</small>
                              <small v-if="plano.filtros.tipo_plano == 'o'">-</small>
                            </td>
                          </template>
                        </tr>
                        <transition name="fade">
                          <tr class="header search-row hidden-print px-0 py-0" v-if="showHospitais">
                            <td class="px-0 py-0" :colspan="colspanPlanos(cenario)">
                              <div class="pa-0">
                                <input type="text" :id="`busca-redes-${cenario.id}`" class="form-control"
                                  v-model="buscaRedes[cenario.id]" :data-cenario-id="cenario.id"
                                  @input="onInputBuscaRedes" placeholder="Buscar um hospital ou região..." />
                              </div>
                            </td>
                          </tr>
                        </transition>
                      </tbody>

                      <transition-group name="list" tag="tbody" :key="`linha-regioes-${index}`" class="mw80 ma-4 pa-4">
                        <template v-if="showHospitais">
                          <template v-for="(regiao, rindex) in searchRedes(cenario.id)">
                            <tr class="header" :key="`tr-regioes-${index}-${regiao.id}-${rindex}`">
                              <template v-for="p in mergePlanos(cenario).length + 1">
                                <td :key="`coluna-regiao-${index}-${rindex}-${p}`" class="px-0 border-bottom"
                                  @click="toggleAllRegiao(cenario, regiao)" v-if="p == 1">
                                  <div class="ml-2 no-gutters">
                                    <b :inner-html.prop="regiao.nome | highlight(buscaRedes[cenario.id])
                                      "></b>
                                    <b-icon icon="caret-down-fill" class="regioes"></b-icon>
                                  </div>
                                </td>
                                <td :key="`coluna-regiao-${index}-${rindex}-${p}`" class="px-0 border-bottom"
                                  @click="toggleAllRegiao(cenario, regiao)" v-if="p > 1"></td>
                              </template>
                            </tr>
                            <template v-if="showCidades(cenario, regiao)">
                              <template v-for="(cidade, cindex) in regiao.cidades">
                                <tr class="header" :key="`tr-cidades-${index}-${regiao.id}-${rindex}-${cidade.id}-${cindex}`
                                  ">
                                  <template v-for="p in mergePlanos(cenario).length + 1">
                                    <td class="px-0 border-bottom" @click="toggleAllCidade(cenario, cidade)" :key="`coluna-cidade-${index}-${regiao.id}-${rindex}-${cidade.id}-${cindex}-${p}`
                                      " v-if="p == 1">
                                      <div class="ml-2 no-gutters">
                                        <span class="fz-14" :inner-html.prop="cidade.nome | highlight(buscaRedes[cenario.id])
                                          " />
                                        <b-icon icon="caret-down-fill" class="regioes"></b-icon>
                                      </div>
                                    </td>
                                    <td class="px-0 border-bottom" @click="toggleAllCidade(cenario, cidade)" :key="`coluna-cidade-${index}-${regiao.id}-${rindex}-${cidade.id}-${cindex}-${p}`
                                      " v-if="p > 1"></td>
                                  </template>
                                </tr>
                                <template v-if="showCredenciados(cenario, cidade)">
                                  <template v-for="(tipo, i) in Object.keys(
                                    cidade.credenciados
                                  )">
                                    <tr class="header" :key="`tr-credenciados-${index}-${regiao.id}-${rindex}-${cidade.id}-${cindex}-${i}`
                                      ">
                                      <template v-for="p in mergePlanos(cenario).length +
                                        1">
                                        <th :key="`coluna-tipo-${index}-${regiao.id}-${rindex}-${cidade.id}-${cindex}-${p}`
                                          " class="eixo" v-if="p == 1">
                                          <div class="row text-left ml-4 no-gutters align-center justify-center">
                                            {{ tipo }}
                                          </div>
                                        </th>
                                        <th :key="`coluna-tipo-${index}-${regiao.id}-${rindex}-${cidade.id}-${cindex}-${p}`
                                          " v-if="p > 1"></th>
                                      </template>
                                    </tr>
                                    <tr :class="{ alternate: crindex % 2 == 0 }" v-for="(credenciado, crindex) in cidade
                                      .credenciados[tipo]" :key="`tr-credenciados-${index}-${regiao.id}-${rindex}-${cidade.id}-${cindex}-${i}-${crindex}`">
                                      <td class="header-row">
                                        <div class="row text-left ml-4 no-gutters align-center justify-center">
                                          <b-link href="#" v-b-modal.modal-localizacao variant="link" class="text-primary"
                                            sm @click="
                                              credenciadoSelecionado = credenciado
                                              " :inner-html.prop="credenciado.resumo
                                                ? credenciado.resumo
                                                : credenciado.nome
                                                | highlight(buscaRedes[cenario.id])
                                                ">
                                          </b-link>
                                        </div>
                                      </td>
                                      <td :id="`tr-credenciados-${index}-${regiao.id}-${rindex}-${cidade.id}-${cindex}-${i}-${crindex}-${i}`
                                        " v-for="(plano, i) in cabCredPlanos(
                                            cenario
                                          )" :key="`tr-credenciados-${index}-${regiao.id}-${rindex}-${cidade.id}-${cindex}-${i}-${crindex}-${i}`
                                          " class="text-center rede-sumario p-2">
                                        

                                        <span :inner-html.prop="cobCredPlanos(plano, credenciado)"
                                          v-b-popover.hover="{ content: obsCredPlanos(plano, credenciado), html: true, customClass: 'credenciado_obs' }" />
                                        <span v-if="obsCredPlanos(plano, credenciado)" variant="link" class="shadow-none"
                                          title="">*</span>

                                      </td>
                                    </tr>
                                  </template>
                                </template>
                              </template>
                            </template>
                          </template>
                        </template>
                      </transition-group>

                      <tbody :key="`linha-valores-${index}`" class="ma-4 pa-4" v-if="showRows('valores')">
                        <tr class="header">
                          <td class="px-0">
                            <div class="row text-left ml-0 no-gutters align-center justify-center"
                              style="cursor: pointer;" v-on:click="showValores = !showValores">
                              <div class="col">
                                <span style="
                                  color: #4d5656;
                                  font-size: 0.8rem !important;
                                ">
                                  Valores
                                  <b-icon icon="caret-down-fill" style="
                                  float: right;
                                  margin-top: 3px;
                                  margin-right: 13px;
                                  font-size: 14px;
                                  color: #212529;
                                "></b-icon>
                                </span>
                              </div>
                            </div>
                          </td>
                          <template v-for="(operadora, indexo) in cenario.operadoras">
                            <b-td class="text-center" v-for="(plano, indexp) in parsePlanos(
                              operadora.grupos
                            )" :key="`valores-total-${index}-${indexo}-${plano.id}-${indexp}`">
                              <transition name="fade">
                                <span class="text-no-wrap" style="width: 2%" v-if="!showValores">
                                  <span class="valor-sumario">
                                    {{ calcularTotal(plano) | valor }}
                                  </span>
                                  <b v-if="plano.calculo.taxa_descricao" variant="link" class="shadow-none"
                                    v-b-popover.hover="{ content: plano.calculo.taxa_descricao, html: true, customClass: 'taxa_descricao' }">*</b>
                                </span>
                              </transition>
                            </b-td>
                          </template>
                        </tr>
                        <tr>
                          <td class="text-left text-dark" style="z-index: 3 !important"
                            :colspan="gerarColspan(cenario.operadoras)">
                            <div class="row" id="row-detalhamento" :style="verificarDetalhamento(cenario.operadoras)">
                              <div class="col-md-3"><span>* Clique para ver o detalhamento</span></div>
                            </div>
                          </td>
                        </tr>
                        <template v-for="(faixa, indexf) in cenario.faixas">
                          <transition name="fade" :key="faixa.slug" v-if="showFaixa(faixa)">
                            <tr v-if="showValores" :class="{ alternate: indexf % 2 == 0 }">
                              <td>
                                <div class="w-100">
                                  <label for="faixa" class="m-0 w-50 text-center">
                                    {{ faixa.label }}
                                  </label>
                                  <input :id="`${cenario.id}-faixa-${faixa.slug}`" type="number" min="0" max="99"
                                    class="m-0 mr-2 w-30 inputVidas text-center" :data-cenarioId="cenario.id"
                                    :data-slug="faixa.slug" v-model="faixa.value" style="float: right;" disabled />
                                </div>
                              </td>
                              <template v-for="(operadora, indexo) in cenario.operadoras">
                                <b-td class="text-center p-2" v-for="(plano, indexp) in parsePlanos(
                                      operadora.grupos
                                    )" :key="`valores-${index}-${indexf}-${indexo}-${plano.id}-${indexp}`">
                                  <b-button variant="link" class="shadow-none m-0 p-0" v-b-popover.hover="popoverValor(faixa.slug, plano.valores)
                                    " title="">
                                    {{
                                      faixaDeValor(
                                        faixa.slug,
                                        plano.calculo.faixas
                                      ) | valor
                                    }}
                                  </b-button>
                                </b-td>
                              </template>
                            </tr>
                          </transition>
                        </template>
                      </tbody>
                    </template>
                    <ResumoGeralTituloPrint :cenarios="isComparative" v-if="showRows('resumo')" />
                    <ResumoGeralVidasPrint :cenarios="isComparative" v-if="showRows('resumo')" />
                    <ResumoGeralGrupoPrint :cenarios="isComparative" v-if="showRows('resumo')" />
                    <ResumoGeralTotalPrint :cenarios="isComparative" v-if="showRows('resumo')" />
                  </table>
                </div>
              </card>
            </div>
            <ModalTabela />
          </section>

          <template>
            <div class="row legendas" style="width: 100%; min-height: 3rem; margin: 0 1rem; align-items: center ;"
              v-if="PlansViewMode === 'tabela'">
              <div class="col-md-3">
                Legendas: <b>H</b> - Internação Efetiva,
              </div>
              <div class="col-md-2">
                <b>PS</b> - Pronto Socorro,
              </div>
              <div class="col-md-2">
                <b>M</b> - Maternidade,
              </div>
              <div class="col-md-2">
                <b>AMB</b> - Ambulatório,
              </div>
              <div class="col-md-2">
                <b>SIM</b> - Possui atendimento
              </div>
            </div>
          </template>


          <div class="col-sm-12" v-if="!vencida">
            <div class="card card-aviso">
              <div class="card-header">
                <p class="card-title text-danger">IMPORTANTE - LEIA COM ATENÇÃO</p>
              </div>
              <div class="card-body text-danger">
                <p class="fz-12">As informações referentes a Preços, Redes, Carências, Documentações, Reembolsos e Condições Contratuais são <b>determinadas pelas</b> operadoras, seguradoras, 
                    administradoras ou outras entidades responsáveis e <b>deverão ser verificadas e conferidas junto</b> à respectiva <b>antes da CONTRATAÇÃO.</b></p>
                <p class="fz-12">Esta é uma <b>ferramenta de simulação</b> destinada a auxiliar no processo de pesquisa. Contudo, é importante destacar que <b>não nos responsabilizamos por possíveis 
                alterações que sejam feitas sem prévio aviso</b>. Para maiores informações e rede credenciada, consulte o site oficial da operadora. Quaisquer outras <b>dúvidas consulte o 
                corretor</b> que lhe enviou esta simulação.</p>
                <p class="fz-12"><b>Ressaltamos o nosso compromisso com a precisão das informações fornecidas</b>, no entanto, reservamo-nos o direito de corrigir eventuais erros identificados, esclarecendo 
                que tais correções <b>não estão vinculadas à efetivação do serviço</b>, que ocorrerá exclusivamente mediante a assinatura do contrato.</p>
                <p class="fz-12"><i>Aos valores apresentados não estão sendo somadas as taxas (exceto quando informado).</i></p>
              </div>
            </div>
          </div>

        </div>
        <ModalContato :hash="hash" :cotacao="cotacaoId" :codigo="indicacao" :cliente_nome="cliente_nome"
          :cliente_email="cliente_email" :cliente_telefone="cliente_telefone" />

        <transition name="fade">
          <div class="compareStripBG" v-if="totalOperadoras > 1">
            <div class="planNumber">{{ totalOperadoras }}</div>
            <button class="compareButton" @click="ChangeViewToTable()">
              <span>
                <font-awesome-icon :icon="['fas', 'list']" style="color: #ffffff; margin-right: .3rem" />
                Comparar
              </span>
            </button>
            <button class="cleanButton" @click="cleanComparative()">
              <span>
                <font-awesome-icon :icon="['fas', 'eraser']" style="margin-right: .3rem" />
                Limpar
              </span>
            </button>
          </div>
        </transition>
      </div>
      <Sidebar :user="user" v-if="source != 'iframe'" />
      <Footer />
    </overlay>
  </div>
</template>

<script>
import { StatsCard } from "@/components/index";
import { PaperTable } from "@/components";
import ModalFilter from "@/components/ModalFilter";
import FlexTableHeaderScroll from "@/components/FlexTableHeaderScroll";
import Overlay from "@/components/Overlay";
import Loader from "@/components/Loader";

import { mapActions, mapGetters } from "vuex";

import Header from "@/layout/cotacao/Header";
import Sidebar from "@/layout/cotacao/Sidebar";
import Footer from "@/layout/cotacao/Footer";
import ModalContato from "@/layout/cotacao/ModalContato";
import ModalTabela from "@/components/ModalTabela";
import ModalLocalizacao from "@/components/ModalLocalizacao";

import PlanCard from "@/components/Cards/PlanCard";

import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(fas);

export default {
  props: ["hash"],
  components: {
    StatsCard,
    PaperTable,
    ModalFilter,
    Header,
    Sidebar,
    Footer,
    ModalContato,
    Overlay,
    Loader,
    ModalTabela,
    ModalLocalizacao,
    PlanCard,
    ResumoGeralTituloPrint: () =>
      import(
        /* webpackChunkName: "resumogeral-titulo-print-chunk" */ "@/components/ResumoGeralTituloPrint"
      ),
    ResumoGeralVidasPrint: () =>
      import(
        /* webpackChunkName: "resumogeral-vidas-print-chunk" */ "@/components/ResumoGeralVidasPrint"
      ),
    ResumoGeralGrupoPrint: () =>
      import(
        /* webpackChunkName: "resumogeral-grupo-print-chunk" */ "@/components/ResumoGeralGrupoPrint"
      ),
    ResumoGeralTotalPrint: () =>
      import(
        /* webpackChunkName: "resumogeral-total-print-chunk" */ "@/components/ResumoGeralTotalPrint"
      )
  },

  data() {
    return {
      Filters: {
        Lodging: '',
        Coverage: '',
        Coparticipation: '',
      },
      novoCenario: [],
      checkedPlans: [],
      Plans: [],
      Filtered: [],
      SelectedGroup: false,
      SelectedToCompare: [],
      SortBy: "",
      IsResponsive: 'mobile',
      PlansViewMode: 'porPlano',
      buscaRedes: [],
      cenarioId: null,
      cenarioObj: null,
      regioesSearch: [],
      filters: [],
      filtros: {
        tipo_plano: null,
        contratacao: null,
        coparticipacao: null,
        compulsorio: null,
        acomodacao: null,
        regras_aceitacao: true,
        profissao: null,
        cidade: null,
        credenciado: null
      },
      user: {
        id: "",
        aplicativo: "",
        barra_url: "",
        cargo: "",
        cartao: "",
        email: "",
        empresa: "",
        login: "",
        logotipo: "",
        logotipo_usuario: "",
        name: "",
        redes: {
          facebook: "",
          google: "",
          instagram: "",
          linkedin: "",
          twitter: "",
          youtube: ""
        },
        site: "",
        status: "",
        telefones: [],
        uf: ""
      },
      cotacaoId: "",
      indicacao: "",
      cliente_nome: "",
      cliente_email: "",
      cliente_telefone: "",
      cenario: null,
      cenarios: [],
      cotacaoData: "",
      cotacaoUf: "",
      cotacaoTitulo: "",
      cotacaoMensagem: "",
      cotacaoArquivos: [],
      validade: "",
      vencida: "",
      data: null,
      source: null,
      showValores: false,
      showHospitais: false,
      credenciadoSelecionado: null,
      regioes: [],
      cidades: [],
      recomendar: [],
      loadingSession: true
    };
  },

  mixins: [FlexTableHeaderScroll],
  computed: {
    ...mapGetters("usuario", ["getSession"]),
    ...mapGetters('modalFilter', ['getFilters', 'getRows']),
    ...mapGetters("share", {
      getCotacao: "getCotacao",
      loadingCotacao: "getLoading",
    }),

    isSimulacaoRoute() {
      return this.$route.path.includes('/simulacao');
    },

    totalOperadoras() {
      return this.novoCenario.reduce((total, objeto) => {
        return total + objeto.operadoras.reduce((operadoraTotal, operadora) => {
          return operadoraTotal + operadora.grupos.length;
        }, 0);
      }, 0);
    },

    isComparative() {
      return this.totalOperadoras > 1 ? this.novoCenario : this.cenarios;
    },

    OnlyPlans() {

      if (!this.SelectedGroup) {
        const PrimeiroGrupo = this.cenarios.length > 0 ? this.cenarios[0].nome : '';
        this.SelectedGroup = PrimeiroGrupo;
      }


      this.Plans = [];

      for (const cenario of this.cenarios) {
        for (const operadora of cenario.operadoras) {
          for (const grupo of operadora.grupos) {
            for (const plano of grupo.planos) {

              const checkedPlan = this.checkedPlans.find(item => item.id === plano.calculo.total_iof);

              this.Plans.push({
                ...plano,
                compulsorio: plano.compulsorio === '1' ? 'sim' : plano.compulsorio === "" || "0" ? 'nao' : 'nao',
                coparticipacao: plano.coparticipacao === '1' ? 'sim' : plano.coparticipacao === "" || "0" ? 'nao' : 'nao',
                operadoraLogo: operadora.logotipoavo,
                operadoraNome: operadora.nome,
                cenarioGrupo: cenario.nome,
                cenarioRegioes: cenario.regioes,
                cenario: cenario,
                operadora: operadora,
                valorTotal: plano.calculo.total,
                totalIOF: plano.calculo.total_iof,
                titulares: plano.calculo.detalhe.t,
                checked: checkedPlan ? checkedPlan.isChecked : false
              });
            }
          }
        }
      }
    },


    filteredList() {
      this.OnlyPlans

      let PlansToFilter = this.Plans.filter(item => {

        const lodgingValid = item.acomodacao.toLowerCase().includes(this.Filters.Lodging.toLowerCase());
        const CoverageValid = item.atuacao.toLowerCase().includes(this.Filters.Coverage.toLowerCase());
        const coparticipationValid = item.coparticipacao.toLowerCase().includes(this.Filters.Coparticipation.toLowerCase());

        return lodgingValid && CoverageValid && coparticipationValid;
      });

      if (this.SortBy === "alphabetic") {
        return PlansToFilter.slice().sort((a, b) => a.nome.localeCompare(b.nome));
      } else if (this.SortBy === "highest") {
        return PlansToFilter.slice().sort((a, b) => b.valorTotal - a.valorTotal);
      } else if (this.SortBy === "lowest") {
        return PlansToFilter.slice().sort((a, b) => a.valorTotal - b.valorTotal);
      } else {
        return PlansToFilter;
      }
    },

    filteredPlanList() {
      return this.filteredList.filter(plano => plano.cenarioGrupo === this.SelectedGroup);
    },

    clientWhatsapp() {
      return this.getCotacao
    },

    baseStyles() {
      let columns =
        this.cenarios.length > 0
          ? this.cenarios[0].operadoras
            .reduce(function (prev, curr) {
              return [...prev, ...curr.grupos];
            }, [])
            .reduce(function (prev, curr) {
              return [...prev, ...curr.planos];
            }, []).length + 1
          : 1;
      let minWidth = columns * 200;
      return {
        "--minWidth": minWidth + "px",
        "--freezeWidth": this.$isMobile() ? "150px" : "150px",
        "--viewportSize": this.viewportSize + "px"
      };


    },
    loadingAll() {
      return !this.loadingCotacao;
    },
    exibirCenarios() {
      return this.cenarios.length > 0

    }
  },
  methods: {
    ...mapActions("share", ["cotacao", "updateAux"]),
    ...mapActions('modalFilter', ['update', 'updateRows']),
    ...mapActions("usuario", ["saveSession"]),
    ...mapActions("notificar", ["enviar"]),
    ...mapActions("cenario", ["updateCenarios", "recuperaCenario",
      "resetRedes", "resetRegioes"]),

    ...mapActions("regiao", ["buscaRegiao"]),
    popoverValor(slug, valores) {
      slug = slug == "59-99" ? "59-+" : slug;
      let valor = valores.hasOwnProperty("unico")
        ? parseFloat(valores["unico"])
        : parseFloat(valores[slug]);
      return `R$ ${valor.toFixed(2)}`.replace(".", ",");
    },

    toggleDrawer() {
      this.hospitalsIsOpen = !this.hospitalsIsOpen;
    },

    cleanComparative() {
      const Uncheck = this.Plans.filter(objeto1 => {
        return this.SelectedToCompare.some(objeto2 => objeto2.id === objeto1.id);
      });

      Uncheck.forEach(objeto => {
        objeto.checked = false;
      });

      this.novoCenario = []
      this.checkedPlans = []
      this.PlansViewMode = 'porPlano'
    },

    CompareSelection(plano, index) {
      const foundPlan = this.Plans.find(objeto => objeto.valorTotal === plano.valorTotal);
      const planExistIndex = this.SelectedToCompare.findIndex(item => item.valorTotal === plano.valorTotal);

      if (foundPlan.checked === false) {
        foundPlan.checked = true;

      } else {
        foundPlan.checked = false;

      }

      if (planExistIndex > -1) {
        this.SelectedToCompare.splice(planExistIndex, 1);

      } else {
        foundPlan.checked = true;
        this.SelectedToCompare.push(foundPlan);

      }
    },

    handleCheckboxChange(plano, index) {
      const foundIndex = this.novoCenario.findIndex(item => item.nome === plano.cenarioGrupo);
      const foundCheckedPlan = this.checkedPlans.find(item => item.id === plano.calculo.total_iof);

      const criarGrupo = {
        compulsorio: plano.operadora.grupos[0].compulsorio,
        coparticipacao: plano.operadora.grupos[0].coparticipacao,
        data_fim: plano.operadora.grupos[0].data_fim,
        data_inicio: plano.operadora.grupos[0].data_inicio,
        fields: plano.operadora.grupos[0].fields,
        id: plano.operadora.grupos[0].id,
        items: plano.operadora.grupos[0].items,
        key_cenario: plano.operadora.grupos[0].key_cenario,
        key_grupo: plano.operadora.grupos[0].key_grupo,
        key_operadora: plano.operadora.grupos[0].key_operadora,
        max_vidas: plano.operadora.grupos[0].max_vidas,
        min_vidas: plano.operadora.grupos[0].min_vidas,
        nome: plano.operadora.grupos[0].nome,
        obstetricia: plano.operadora.grupos[0].obstetricia,
        odonto: plano.operadora.grupos[0].odonto,
        oper: plano.operadora.grupos[0].oper,
        oper_avo: plano.operadora.grupos[0].oper_avo,
        oper_mae: plano.operadora.grupos[0].oper_mae,
        planos: [{ ...plano }],
        redes: plano.operadora.grupos[0].redes,
        reembolso: plano.operadora.grupos[0].reembolso,
      };

      if (foundIndex === -1 ) {
      this.novoCenario.push({
          id: plano.cenario.id,
          nome: plano.cenarioGrupo,
          operadoras: [
            {
              ...plano.operadora,
              grupos: [{ ...criarGrupo }],
            },
          ],
          regioes: plano.cenarioRegioes,
          faixas: plano.cenario.faixas,
          redes: plano.cenario.redes,
        });

        this.checkedPlans.push({
          id: plano.calculo.total_iof,
          isChecked: true,
        });
      }

      if (foundIndex != -1 && foundCheckedPlan === undefined) {

        const operadoraIndex = this.novoCenario[foundIndex].operadoras.findIndex(operadora => {
          return operadora.id === plano.operadora.id;
        });

        if(operadoraIndex != -1){
          this.novoCenario[foundIndex].operadoras[operadoraIndex].grupos.push({ ...criarGrupo });
        this.checkedPlans.push({
          id: plano.calculo.total_iof,
          isChecked: true,
        });
        } else if (operadoraIndex === -1) {

        this.novoCenario[foundIndex].operadoras.push({
          ...plano.operadora,
              grupos: [{ ...criarGrupo }],
        })

        this.checkedPlans.push({
          id: plano.calculo.total_iof,
          isChecked: true,
        });
      }
      } else if (foundIndex != -1 && foundCheckedPlan.isChecked === true) {

        const operadoraIndex = this.novoCenario[foundIndex].operadoras.findIndex(operadora => {
          return operadora.id === plano.operadora.id;
        });

        const foundGroupIndex = this.novoCenario[foundIndex].operadoras[operadoraIndex].grupos.findIndex(grupo => {
          return grupo.id === plano.operadora.grupos[0].id;
        });

        this.novoCenario[foundIndex].operadoras[operadoraIndex].grupos.splice(foundGroupIndex, 1)
        foundCheckedPlan.isChecked = false;

        if (this.novoCenario[foundIndex].operadoras[operadoraIndex].grupos.length === 0) {
          this.novoCenario[foundIndex].operadoras.splice(operadoraIndex, 1);
        }

      } else if (foundIndex != -1 && foundCheckedPlan.isChecked === false) {

        this.novoCenario[foundIndex].operadoras.push({
          ...plano.operadora,
          grupos: [{ ...criarGrupo }],
        })
        foundCheckedPlan.isChecked = true;

      }

    },

    ChangeSortByFilter(event) {
      this.SortBy = event.target.value
    },
    ChangeLodgingFilter(event) {
      this.Filters.Lodging = event.target.value
    },
    ChangeCoparticipationFilter(event) {
      this.Filters.Coparticipation = event.target.value
    },
    ChangeCoverageFilter(event) {
      this.Filters.Coverage = event.target.value
    },

    faixaDeValor(slug, faixas) {
      slug = slug == "59-99" ? "59-+" : slug;
      return faixas[slug] > 0 ? parseFloat(faixas[slug]) : "-";
    },
    calcularTotal(plano) {
      return plano.filtros.regras_aceitacao && (plano.alertas && plano.alertas.length > 0)
        ? 0
        : plano.taxas.iof == true
          ? plano.calculo.total_iof
          : plano.calculo.total;
    },
    vidas(cenario) {
      return cenario.faixas
        .map(f => Number(f.value))
        .reduce((o, c) => parseInt(o) + parseInt(c));
    },
    totalHospitais(plano, regioes) {
      let total = 0;
      if(typeof regioes == 'object') {
        regioes.forEach(regiao => {
          regiao.cidades.forEach(cidade => {
            total += cidade.credenciados.hasOwnProperty("Hospitais")
              ? cidade.credenciados["Hospitais"].filter(
                c =>
                  c.redes
                    .map(c => parseInt(c))
                    .indexOf(parseInt(plano.rede_id)) != -1
              ).length
              : 0;
          });
        });
      }
 
      return total;
    },
    totalCentros(plano, regioes) {
      let total = 0;
      if(typeof regioes == 'object') {
        regioes.forEach(regiao => {
          regiao.cidades.forEach(cidade => {
            total += cidade.credenciados.hasOwnProperty("Centros Médicos")
              ? cidade.credenciados["Centros Médicos"].filter(
                c =>
                  c.redes
                    .map(c => parseInt(c))
                    .indexOf(parseInt(plano.rede_id)) != -1
              ).length
              : 0;
          });
        });
      }
      return total;
    },
    totalLaboratorios(plano, regioes) {
      let total = 0;
      if(typeof regioes == 'object') {
        regioes.forEach(regiao => {
          regiao.cidades.forEach(cidade => {
            total += cidade.credenciados.hasOwnProperty("Laboratórios")
              ? cidade.credenciados["Laboratórios"].filter(
                c =>
                  c.redes
                    .map(c => parseInt(c))
                    .indexOf(parseInt(plano.rede_id)) != -1
              ).length
              : 0;
          });
        });
      }
      return total;
    },
    toggleAllRegiao(cenario, regiao) {
      let i = this.regioes.findIndex(regiao => regiao.cenarioId == cenario.id);
      if (i != -1) {
        let x = this.regioes[i].regioes.findIndex(r => r == regiao.id);
        if (x != -1) {
          this.regioes[i].regioes.splice(x, 1);
        } else {
          this.regioes[i].regioes.push(regiao.id);
        }
      } else {
        this.regioes.push({ cenarioId: cenario.id, regioes: [regiao.id] });
      }
      localStorage.setItem("toggleAllRegiao", JSON.stringify(this.regioes));
    },
    showCidades(cenario, regiao) {
      let c = this.regioes.find(r => r.cenarioId == cenario.id);
      return c ? c.regioes.findIndex(r => r == regiao.id) != -1 : false;
    },
    toggleAllCidade(cenario, cidade) {
      let i = this.cidades.findIndex(cidade => cidade.cenarioId == cenario.id);
      if (i != -1) {
        let x = this.cidades[i].cidades.findIndex(r => r == cidade.id);
        if (x != -1) {
          this.cidades[i].cidades.splice(x, 1);
        } else {
          this.cidades[i].cidades.push(cidade.id);
        }
      } else {
        this.cidades.push({ cenarioId: cenario.id, cidades: [cidade.id] });
      }
      localStorage.setItem("toggleAllCidade", JSON.stringify(this.cidades));
    },
    showCredenciados(cenario, cidade) {
      let c = this.cidades.find(r => r.cenarioId == cenario.id);
      return c ? c.cidades.findIndex(r => r == cidade.id) != -1 : false;
    },
    toggleRecomendar(cenario, plano) {
      const input = document.querySelector(
        `#input-recomendar-${cenario.id}-${plano.id}`
      );
      const td = input.closest("td");
      const indexTd = this.getTdIndex(td);
      const table = document.getElementById("table-group");
      const tds = table.querySelectorAll(`tr td:nth-child(${indexTd})`);

      let i = this.recomendar.findIndex(
        recomendar => recomendar.cenarioId == cenario.id
      );
      if (i != -1) {
        let x = this.recomendar[i].planos.findIndex(p => p == plano.id);
        if (x != -1) {
          this.recomendar[i].planos.splice(x, 1);
          tds.forEach(td =>
            td.classList.remove("plano_selecionado", "plano_selecionado2")
          );
        } else {
          this.recomendar[i].planos.push(plano.id);
          tds.forEach((td, index) => {
            index % 2 == 1
              ? td.classList.add("plano_selecionado")
              : td.classList.add("plano_selecionado2");
          });
        }
      } else {
        this.recomendar.push({ cenarioId: cenario.id, planos: [plano.id] });
        tds.forEach((td, index) => {
          index % 2 == 1
            ? td.classList.add("plano_selecionado")
            : td.classList.add("plano_selecionado2");
        });
      }
    },
    groupBy(list, keyGetter) {
      const map = new Map();
      list.forEach(item => {
        const key = keyGetter(item);
        const collection = map.get(key);
        if (!collection) {
          map.set(key, [item]);
        } else {
          collection.push(item);
        }
      });

      return Array.from(map).map(p => ({
        key: p[0],
        value: p[1]
      }));
    },
    distinct(x, i, a) {
      return a.indexOf(x) === i;
    },
    replaceSepecialChars(str) {
      return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    },
    cabCredPlanos(cenario) {
      console.log("SimulacaoGrupo:cabCredPlanos");
      let planos = cenario.operadoras
        .reduce(function (prev, curr) {
          return [...prev, ...curr.grupos];
        }, [])
        .reduce(function (prev, curr) {
          return [...prev, ...curr.planos];
        }, []);
      let redes = cenario.redes.map(c => parseInt(c));
      return planos.filter(plano => {
        // Odonto não possui rede
        return plano.filtros.tipo_plano == "o"
          ? true
          : redes.indexOf(parseInt(plano.rede_id)) != -1;
      });
    },
    cobCredPlanos(plano, credenciado) {
      //ajustando para novo modelo de rede, deixar somente esta condição após setembro/2023
      if (typeof credenciado.cob == 'object') {
        return credenciado.redes
          .map(r => parseInt(r))
          .indexOf(parseInt(plano.rede_id)) != -1
          ? credenciado.cob[plano.rede_id]
            .split(",")
            .map(c => `<span>${c}</span>`)
            .join(",")
          : " - ";
      } else {
        return credenciado.redes
          .map(r => parseInt(r))
          .indexOf(parseInt(plano.rede_id)) != -1
          ? credenciado.cob
            .split(",")
            .map(c => `<span>${c}</span>`)
            .join(",")
          : " - ";
      }

    },
    obsCredPlanos(plano, credenciado) {
      if (!credenciado.hasOwnProperty('obs')) {
        return;
      }
      //ajustando para novo modelo de rede, deixar somente esta condição após setembro/2023
      if (typeof credenciado.cob == 'object') {
        return credenciado.obs[plano.rede_id] ?
          credenciado.obs[plano.rede_id] :
          ''
      } else {
        return credenciado.obs ?
          credenciado.obs :
          ''
      }
    },
    parsePlanos(grupos) {
      return grupos.reduce(function (prev, curr) {
        return [...prev, ...curr.planos];
      }, []);
    },
    parseRegioes(operadoras) {
      return operadoras.reduce(function (prev, curr) {
        return [...prev, ...curr.regioes];
      }, []);
    },
    mergeRegioes(operadoras) {
      let merged = {};
      operadoras.forEach(operadora => {
        _.merge(merged, operadora.regioes);
      });
      return merged;
    },
    searchRedes(cenarioId) {
      if (this.regioesSearch.length > 0 && this.regioesSearch[cenarioId]) {
        return this.regioesSearch[cenarioId];
      } else {
        let self = this;
        let buscaRedes = this.buscaRedes[cenarioId] ? this.buscaRedes[cenarioId] : "";
        let redeChildren = this.children(this.getFilters, 'hospitais')
        let cenarioRedeChildren = redeChildren.length > 0 ? redeChildren.find(c => c.data.id == cenarioId) : [];
        let filterRedeChildren = cenarioRedeChildren.hasOwnProperty('children') ? cenarioRedeChildren.children : [];
        let cenario = this.cenarios.find(c => c.id == cenarioId)
        let regioes = JSON.parse(JSON.stringify(cenario.regioes));
        regioes = regioes.filter(regiao => {
          if (!self.checked(filterRedeChildren, regiao.nome)) return false
          let filterRegiaoChildren = self.children(filterRedeChildren, regiao.nome)
          let term = self
            .replaceSepecialChars(buscaRedes)
            .replace(/[\s]/, ".*");
          let reg = new RegExp("(" + term + ")", "ig");
          regiao.cidades = regiao.cidades.filter(cidade => {
            if (!self.checked(filterRegiaoChildren, cidade.nome)) return false
            let filterCidadeChildren = self.children(filterRegiaoChildren, cidade.nome)
            let hospitais = []
            let laboratorios = []
            let centros = []
            if (cidade.credenciados.hasOwnProperty('Hospitais') && self.checked(filterCidadeChildren, 'Hospitais')) {
              let filterHospitalChildren = self.children(filterCidadeChildren, 'Hospitais')
              hospitais = cidade.credenciados['Hospitais'].filter(cred => {
                if (!self.checked(filterHospitalChildren, cred.id)) return false
                if (reg.test(self.replaceSepecialChars(cred.nome))) {
                  return true
                }
              })
            }
            if (cidade.credenciados.hasOwnProperty('Laboratórios') && self.checked(filterCidadeChildren, 'Laboratórios')) {
              let filterLaboratorioChildren = self.children(filterCidadeChildren, 'Laboratórios')
              laboratorios = cidade.credenciados['Laboratórios'].filter(cred => {
                if (!self.checked(filterLaboratorioChildren, cred.id)) return false
                if (reg.test(self.replaceSepecialChars(cred.nome))) {
                  return true
                }
              })
            }
            if (cidade.credenciados.hasOwnProperty('Centros Médicos') && self.checked(filterCidadeChildren, 'Centros Médicos')) {
              let filterCentroMedicoChildren = self.children(filterCidadeChildren, 'Centros Médicos')
              centros = cidade.credenciados['Centros Médicos'].filter(cred => {
                if (!self.checked(filterCentroMedicoChildren, cred.id)) return false
                if (reg.test(self.replaceSepecialChars(cred.nome))) {
                  return true
                }
              })
            }
            cidade.credenciados['Hospitais'] = hospitais
            if (hospitais.length == 0) delete cidade.credenciados['Hospitais']
            cidade.credenciados['Laboratórios'] = laboratorios
            if (laboratorios.length == 0) delete cidade.credenciados['Laboratórios']
            cidade.credenciados['Centros Médicos'] = centros
            if (centros.length == 0) delete cidade.credenciados['Centros Médicos']
            if (Object.values(cidade.credenciados).flat().length > 0) {
              return true
            } else {
              return reg.test(self.replaceSepecialChars(cidade.nome))
            }
          });
          if (regiao.cidades.length > 0) {
            return true
          } else {
            return reg.test(self.replaceSepecialChars(regiao.nome))
          }
        });
        return regioes
      }
    },
    onInputBuscaRedes(e) {
      let cenarioId = parseInt(e.target.getAttribute("data-cenario-id"));
      if (this.cenarioId !== cenarioId) {
        this.cenarioId = cenarioId;
        this.cenarioObj = this.cenarios.find(
          cenario => cenario.id == cenarioId
        );
      }
      if (this.cenarioObj) {
        let self = this;
        let buscaRedes = this.buscaRedes[cenarioId] ? this.buscaRedes[cenarioId] : "";
        let filterRedeChildren = this.children(this.getFilters, 'hospitais').find(c => c.data.id == cenarioId).children
        let regioes = JSON.parse(JSON.stringify(this.cenarioObj.regioes));
        regioes = regioes.filter(regiao => {
          if (!self.checked(filterRedeChildren, regiao.nome)) return false
          let filterRegiaoChildren = self.children(filterRedeChildren, regiao.nome)
          let term = self
            .replaceSepecialChars(buscaRedes)
            .replace(/[\s]/, ".*");
          let reg = new RegExp("(" + term + ")", "ig");
          regiao.cidades = regiao.cidades.filter(cidade => {
            if (!self.checked(filterRegiaoChildren, cidade.nome)) return false
            let filterCidadeChildren = self.children(filterRegiaoChildren, cidade.nome)
            let hospitais = [];
            let laboratorios = [];
            let centros = [];
            if (cidade.credenciados.hasOwnProperty('Hospitais') && self.checked(filterCidadeChildren, 'Hospitais')) {
              let filterHospitalChildren = self.children(filterCidadeChildren, 'Hospitais')
              hospitais = cidade.credenciados['Hospitais'].filter(cred => {
                if (!self.checked(filterHospitalChildren, cred.id)) return false
                if (reg.test(self.replaceSepecialChars(cred.nome))) {
                  return true
                }
              })
            }
            if (cidade.credenciados.hasOwnProperty('Laboratórios') && self.checked(filterCidadeChildren, 'Laboratórios')) {
              let filterLaboratorioChildren = self.children(filterCidadeChildren, 'Laboratórios')
              laboratorios = cidade.credenciados['Laboratórios'].filter(cred => {
                if (!self.checked(filterLaboratorioChildren, cred.id)) return false
                if (reg.test(self.replaceSepecialChars(cred.nome))) {
                  return true
                }
              })
            }
            if (cidade.credenciados.hasOwnProperty('Centros Médicos') && self.checked(filterCidadeChildren, 'Centros Médicos')) {
              let filterCentroMedicoChildren = self.children(filterCidadeChildren, 'Centros Médicos')
              centros = cidade.credenciados['Centros Médicos'].filter(cred => {
                if (!self.checked(filterCentroMedicoChildren, cred.id)) return false
                if (reg.test(self.replaceSepecialChars(cred.nome))) {
                  return true
                }
              })
            }
            cidade.credenciados["Hospitais"] = hospitais;
            if (hospitais.length == 0) delete cidade.credenciados["Hospitais"];
            cidade.credenciados["Laboratórios"] = laboratorios;
            if (laboratorios.length == 0)
              delete cidade.credenciados["Laboratórios"];
            cidade.credenciados["Centros Médicos"] = centros;
            if (centros.length == 0)
              delete cidade.credenciados["Centros Médicos"];
            if (Object.values(cidade.credenciados).flat().length > 0) {
              return true;
            } else {
              return reg.test(self.replaceSepecialChars(cidade.nome));
            }
          });
          if (regiao.cidades.length > 0) {
            return true;
          } else {
            return reg.test(self.replaceSepecialChars(regiao.nome));
          }
        });
        this.regioesSearch[cenarioId] = buscaRedes.length > 0 ? regioes : this.cenarioObj.regioes;
      }
    },
    colspanPlanos(cenario) {
      return (
        cenario.operadoras
          .reduce(function (prev, curr) {
            return [...prev, ...curr.grupos];
          }, [])
          .reduce(function (prev, curr) {
            return [...prev, ...curr.planos];
          }, []).length + 1
      );
    },
    mergePlanos(cenario) {
      return cenario.operadoras
        .reduce(function (prev, curr) {
          return [...prev, ...curr.grupos];
        }, [])
        .reduce(function (prev, curr) {
          return [...prev, ...curr.planos];
        }, []);
    },
    showRecomendar(cenario, plano) {
      let show = false;
      if (this.recomendar.length > 0) {
        let c = this.recomendar.find(r => r.cenarioId == cenario.id);
        show = c ? c.planos.findIndex(r => r == plano.id) != -1 : false;

        if (cenario.id) {
          let vm = this;
          setTimeout(function () {
            const input = document.querySelector(
              `#textarea-recomendar-${cenario.id}-${plano.id}`
            );
            if (input) {
              const td = input.closest("td");
              const indexTd = vm.getTdIndex(td);
              const table = document.getElementById("table-group");
              const tds = table.querySelectorAll(`tr td:nth-child(${indexTd})`);
              if (show) {
                tds.forEach((td, index) => {
                  index % 2 == 1
                    ? td.classList.add("plano_selecionado")
                    : td.classList.add("plano_selecionado2");
                });
              } else {
                tds.forEach(td =>
                  td.classList.remove("plano_selecionado", "plano_selecionado2")
                );
              }
            }
          }, 800);
        }
      }
      return show;
    },
    getTdIndex(td) {
      let i = 1;
      while ((td = td.previousSibling) != null) i++;
      return i;
    },
    showModalOperadora() {
      this.$root.$emit(
        "bv::show::modal",
        "modal-operadora",
        "#btnShowOperadora"
      );
    },
    maisInformacoes(cenarioId, operadora, plano, tab) {
      console.log(tab)
      this.updateAux({
        id: cenarioId,
        operadora: operadora,
        plano: plano,
        tab: tab ? tab : "valores"
      });

      this.$bvModal.show("modal-tabela");
    },
    modalReembolso(cenario, operadora, plano) {
      let oper = cenario.operadoras.find(o => {
        return (
          o.id == operadora.id &&
          o.filtros.tipo_plano == operadora.filtros.tipo_plano &&
          o.filtros.contratacao == operadora.filtros.contratacao
        );
      });
      if (oper) {
        this.updateAux({
          id: cenario.id,
          operadora: oper,
          plano: plano,
          tab: "reembolso"
        });
      }
      this.$bvModal.show("modal-tabela");
    },
    getLoadAllData() {
      return !this.loadingCotacao;
    },
    async modalOpen(tipo) {
      if (this.getLoadAllData()) {
        if (tipo == "impressao") {
          this.print();
        }
      }
    },
    async print() {
      this.loadingSession = false;
      await this.saveSession({
        id: this.hash,
        data: {
          user: this.user,
          cenarios: this.cenarios,
          filters: this.getFilters,
          rows: this.getRows
        }
      });
      this.loadingSession = true;
      const cotacao_id = localStorage.getItem("cotacao_id");

      const cenario = this.cenarios[0];
      const operadora = cenario.operadoras[0];
      const filtros = operadora.filtros;

      let routeData = this.$router.resolve({
        name: "simulacaoDetalhePrint",
        params: {
          id: cotacao_id ? "cotacao" : operadora.id
        },
        query: {
          tipo_plano: filtros.tipo_plano,
          contratacao: filtros.contratacao,
          compulsorio: filtros.compulsorio == 2 ? '' : filtros.compulsorio == 1 ? 's' : 'n',
          coparticipacao: filtros.coparticipacao == 2 ? '' : filtros.coparticipacao == 1 ? 's' : 'n',
          acomodacao: filtros.acomodacao == 2 ? '' : filtros.acomodacao == 1 ? 'a' : 'e',
          regras_aceitacao: filtros.regras_aceitacao ? 's' : 'n',
          cidade: filtros.cidade ? filtros.cidade.id : '',
          credenciado: filtros.credenciado ? filtros.credenciado : '',
          entidade: filtros.entidade_profissao?.tipo == 'e' ? filtros.entidade_profissao.value.id : '',
          profissao: filtros.entidade_profissao?.tipo == 'p' ? filtros.entidade_profissao.value.id : '',
          hash: this.hash
        }
      });
      window.open(routeData.href, "_blank");
    },
    showRows(key) {
      let show = this.getRows && this.getRows.length > 0 ? this.getRows.filter(t => t.key == key && t.show == 1).length > 0 : false
      return show;
    },
    hasRecomendar() {
      let planos = this.recomendar.length > 0 ? this.recomendar.reduce(function (prev, curr) {
        return [...prev, ...curr.planos];
      }, []) : [];
      return planos.length > 0
    },
    showFaixa(faixa) {
      let show = true;
      let ops = [...this.getFilters]
      let filter = ops.filter(filter => filter.data.item == 'valores')
      let obj = filter.length > 0 ? filter.shift(1) : {}
      let state = obj.hasOwnProperty('state') ? obj.state.indeterminate || obj.state.checked : false;
      if (state) {
        show = obj.children.filter(c => {
          let slug = `${c.data.min.toString().padStart(2, "0")}-${c.data.max.toString().padStart(2, "0")}`;
          return slug == faixa.slug && (c.hasOwnProperty('state') ? c.state.indeterminate || c.state.checked : false)
        }).length > 0
      }
      return show;
    },
    checked(filters, type) {
      let ops = [...filters]
      let filter = ops.filter(filter => filter.data.item == type)
      let obj = filter.length > 0 ? filter.shift(1) : {}
      return obj.hasOwnProperty('state') ? obj.state.indeterminate || obj.state.checked : false
    },
    children(filters, key) {
      let filter = filters.find(f => f.data.item == key)
      return filter ? filter.children : []
    },
    gerarColspan(operadoras) {
      let cspan = 1;
      if (operadoras.length > 0) {
        operadoras.forEach(o => {

          o.grupos.forEach(g => {
            cspan += g.planos.length;
          });
        })
      }

      return cspan;
    },
    verificarDetalhamento(operadoras) {
      let exibir = false;
      if (operadoras.length > 0) {
        operadoras.forEach(o => {
          o.grupos.forEach(g => {
            g.planos.forEach(p => {
              if (!exibir && typeof p.calculo.taxa_descricao === 'string' && p.calculo.taxa_descricao.length > 0) {
                exibir = true;
              }
            });
          })
        })
      }
      return exibir ? 'display:flex' : 'display:none';
    },

    ChangeViewToCard() {
      this.PlansViewMode = 'porPlano'
      sessionStorage.setItem(`ViewMode${this.hash}`, this.PlansViewMode)
    },

    ChangeViewToTable() {
      this.PlansViewMode = 'tabela'
      sessionStorage.setItem(`ViewMode${this.hash}`, this.PlansViewMode)
    },
    ChangeViewToResult() {
      this.PlansViewMode = 'resultado'
      sessionStorage.setItem(`ViewMode${this.hash}`, this.PlansViewMode)
    },

    ChangeIsResponsiveToTrue() {
      this.IsResponsive = "mobile";
      sessionStorage.setItem(`IsResponsive${this.hash}`, this.IsResponsive);
      window.location.reload()
    },

    ChangeIsResponsiveToFalse() {
      this.IsResponsive = "desktop";
      sessionStorage.setItem(`IsResponsive${this.hash}`, this.IsResponsive);
      window.location.reload()
    },

    ChangeGroupFilter(Group) {
      this.SelectedGroup = Group;
    },
  },
  watch: {
    tabIndex() {
      this.busca = "";
    },
    showHospitais(current) {
      localStorage.setItem("showHospitais", current ? 1 : 0);
    },
    showValores(current) {
      localStorage.setItem("showValores", current ? 1 : 0);
    },
  },
  async created() {
    const id = localStorage.getItem(process.env.VUE_APP_CLIENT_ID);
    const json = JSON.parse(id);
    let corretor = json?.user;

    this.tabs = [
      "valores",
      "rede",
      "reembolso",
      "carencia",
      "docs",
      "info",
      "arquivos"
    ];

    this.source = this.$route.query.source || "";

    await this.cotacao(this.hash);
    const cotacao = this.getCotacao;

    if (!corretor) {
      await this.enviar({ codigo: this.hash, tipo: 1 });
    }

    this.cotacaoId = cotacao.id;
    this.indicacao = cotacao.indicacao;
    this.cenarios = cotacao.detalhes.cenarios;
    this.cliente_nome = cotacao.nome;
    this.cliente_email = cotacao.email;
    this.cliente_telefone = cotacao.telefone;
    this.cotacaoData = cotacao.data;
    this.cotacaoUf = cotacao.opcoes.cidade.uf;
    this.cotacaoTitulo = cotacao.titulo;
    this.cotacaoMensagem = cotacao.opcoes.mensagem.replace(/(\n|\r)/ig, '<br/>');
    this.cotacaoArquivos = cotacao.detalhes.arquivos;
    this.filtros = cotacao.parametros.filtros;
    this.update(cotacao.detalhes.filters);
    this.updateRows(cotacao.detalhes.rows);

    this.user = cotacao.opcoes.user;

    this.validade = cotacao.validade;
    this.vencida = cotacao.vencida;

    this.recomendar = cotacao.detalhes.recomendacoes;

    this.PlansViewMode = sessionStorage.getItem(`ViewMode${this.hash}`) ? sessionStorage.getItem(`ViewMode${this.hash}`) : cotacao.opcoes.visualizacao;
    this.IsResponsive = sessionStorage.getItem(`IsResponsive${this.hash}`) ? sessionStorage.getItem(`IsResponsive${this.hash}`) : cotacao.opcoes.responsividade;

    if (!this.PlansViewMode) this.PlansViewMode = 'tabela'
    if (!this.IsResponsive) this.IsResponsive = 'mobile'

    const metaViewport = document.getElementsByClassName('ViewMode');
    let ResponsiveConfig = "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0, shrink-to-fit=no";
    let NoResponsiveConfig = "width=device-width, initial-scale=0.2, maximum-scale=1.0, user-scalable=0, shrink-to-fit=no";

    if (this.IsResponsive === "desktop") {
      metaViewport.viewport.setAttribute("content", NoResponsiveConfig);
    } else {
      metaViewport.viewport.setAttribute("content", ResponsiveConfig);
    }

    let vm = this;
    setTimeout(() => {
      vm.flexTableHeaderScroll();
    }, 5000);
  },
  mounted() {
    this.$nextTick(function () {
      let vm = this;
      setTimeout(() => {
        vm.flexTableHeaderScroll();
      }, 5000);
    });
  }
};
</script>


<style lang="scss" scoped>
table#table-group {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  min-width: var(--minWidth);
}

table#table-group .eixo {
  z-index: 3 !important;
}

table#table-group th.eixo.white {
  width: var(--freezeWidth);
}

table#table-group thead tr:first-child th {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 2;
}

table#table-group .operadora {
  padding: 0 1px;
}

table#table-group .white {
  background-color: #fff !important;
  border-color: #fff !important;
}

table#table-group td:first-child,
table#table-group th:first-child {
  position: -webkit-sticky;
  position: sticky;
  left: 0;
  z-index: 1;
  background: #fff;
}

table#table-group>thead>tr>th,
table#table-group>tbody>tr>th,
table#table-group>tfoot>tr>th {
  padding: 0 !important;
  font-size: 14px !important;
}

table#table-group>thead>tr>th,
table#table-group>tbody>tr>th,
table#table-group>tfoot>tr>th,
table#table-group>thead>tr>td,
table#table-group>tbody>tr>td,
table#table-group>tfoot>tr>td {
  background-color: #fff;
}

table#table-group thead tr>th,
table#table-group thead tr>td,
table#table-group tbody tr>th,
table#table-group tbody tr>td,
table#table-group tfoot tr>th,
table#table-group tfoot tr>td {
  border: none;
}

table#table-group tr.alternate th,
table#table-group tr.alternate td {
  background-color: #f2f2f2;
  -webkit-print-color-adjust: exact;
}

.content-wrapper {
  position: relative;
  background-color: #ecf0f5;
  -webkit-transition: -webkit-transform 0.3s ease-in-out,
    margin 0.3s ease-in-out;
  -moz-transition: -moz-transform 0.3s ease-in-out, margin 0.3s ease-in-out;
  -o-transition: -o-transform 0.3s ease-in-out, margin 0.3s ease-in-out;
  transition: transform 0.3s ease-in-out, margin 0.3s ease-in-out;
  margin-left: 230px;
  z-index: 820;
  padding: 15px;
  min-height: 780px;
}

.sidebar-collapse .main-sidebar,
.sidebar-collapse #header-logo-text {
  display: none;
}

@media (max-width: 767px) {
  .hidden-xs {
    display: none !important;
  }

  .main-header .navbar {
    margin: 0 !important;
  }

  .content-wrapper,
  .main-footer {
    margin-left: 0;
  }
}

.sidebar-collapse .content-wrapper,
.sidebar-collapse nav.navbar.navbar-static-top {
  margin-left: 0 !important;
}

@media (min-width: 768px) {

  .sidebar-mini.sidebar-collapse .content-wrapper,
  .sidebar-mini.sidebar-collapse .right-side,
  .sidebar-mini.sidebar-collapse .main-footer {
    margin-left: 50px;
    z-index: 840;
  }
}

@media (max-width: 767px) {
  .main-sidebar {
    -webkit-transform: translate(-230px, 0);
    -ms-transform: translate(-230px, 0);
    -o-transform: translate(-230px, 0);
    transform: translate(-230px, 0);
  }

  .main-sidebar {
    padding-top: 100px;
  }
}

@media (max-width: 767px) {
  .sidebar-open .main-sidebar {
    -webkit-transform: translate(0, 0);
    -ms-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
  }
}

@media (max-width: 767px) {

  .sidebar-open .content-wrapper,
  .sidebar-open .main-footer {
    -webkit-transform: translate(230px, 0);
    -ms-transform: translate(230px, 0);
    -o-transform: translate(230px, 0);
    transform: translate(230px, 0);
  }
}

.navbar-nav {
  margin: 7.5px -15px;
}

@media (min-width: 768px) {
  .navbar-nav {
    float: left;
    margin: 0;
  }
}

.navbar-nav>li>a {
  padding-top: 10px;
  padding-bottom: 10px;
  line-height: 20px;
}

@media (min-width: 768px) {
  .navbar-nav>li>a {
    padding-top: 11px;
    padding-bottom: 15px;
  }
}

@media (max-width: 767px) {

  .content-wrapper,
  .main-footer {
    margin-left: 0 !important;
  }
}

.b-overlay {
  z-index: 999 !important;
}

.scroll-button {
  position: absolute;
  margin-top: 0px;
  min-height: 35px;
  width: 15px;
  overflow: hidden;
  background: #009b3a;
  color: #fff !important;
  z-index: 100;
  border: 1px solid #058634;
}

.scroll-button.float-left {
  left: 0px;
}

.scroll-button.float-right {
  right: 0px;
}

.no-padding {
  padding: 0;
}

.no-margin {
  margin: 0;
}

div.logo-operadora {
  display: inline-block;
  vertical-align: top;
  margin-left: 10px;
}

.cenario {
  width: 100%;
  height: 100% !important;
  min-height: 100% !important;
  overflow-x: auto;
  overflow-y: visible;
}

.cenario-scroll {
  max-height: 100vh;
}

.plano-area {
  height: auto;
  position: relative;
  font-weight: 400;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

.mw80 {
  max-width: 80%;
}

.scroll-button {
  position: absolute;
  margin-top: 0px;
  min-height: 20px;
  width: 20px;
  overflow: hidden;
  background: rgb(243, 187, 69);
  color: #fff !important;
  z-index: 100;
  border: 1px solid #dba635;
}

.scroll-button.float-left {
  left: 15px;
}

.scroll-button.float-right {
  right: 15px;
}

.operadora>.logo {
  background-color: #fff;
  border-bottom: solid grey;
  height: 75px;
  padding: 0 10px 5px 10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  flex-direction: column;
}

.operadora>.logo img {
  max-height: 100%;
  max-width: 120px;
}

table#table-group td:first-child::after,
table#table-group tr:nth-child(2) th:first-child::after {
  content: "";
  position: absolute;
  height: 100%;
  right: 0;
  top: 0;
  border-right: 1px solid #eee;
}

.rede-sumario small {
  clear: both;
  display: block;
  font-size: 13px !important;
}

.mais-informacoes {
  font-size: 13px !important;
}

.header-row td {
  background-color: #fff !important;
  padding: 0;
}

.header-row td div {
  width: calc(var(--viewportSize) - var(--scrollWidth));
  position: -webkit-sticky;
  position: sticky;
  left: 0;
  padding: 4px 8px;
}

#searchh-input {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  line-height: 20px;
  padding: 5px 5px 5px 35px !important;
  max-width: 100%;
  min-width: 0;
  width: 100%;
  background-image: url("../assets/img/search.svg");
  background-position: 8px 12px;
  background-repeat: no-repeat;
  background-size: 15px;
}

.text-no-wrap {
  white-space: nowrap !important;
}

.valor-sumario {
  font-size: 20px;
}

.primary--text {
  color: #4285f4 !important;
  caret-color: #4285f4 !important;
}

.pointer,
.pointer * {
  cursor: pointer;
}

.credenciado {
  max-width: 100px;
  padding-left: 40px;
}

label[for="faixa"] {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  color: #4d5656;
  font-size: 0.8rem !important;
}

input#faixa {
  width: 45px;
  height: 28px;
  -webkit-box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  float: right;
  background: #fff;
  border-radius: 2px;
  padding: 0 2px;
  border: 1px solid #eee;
  text-align: right;
}

.grupo {
  font-size: 16px;
  font-weight: bold;
}

.custom-control {
  z-index: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active em versões anteriores a 2.1.8 */
  {
  opacity: 0;
}

span.underline {
  text-decoration: underline;
  cursor: pointer;
}

// .redes {
//   width: 100%;
//   height: 100% !important;
//   min-height: 100% !important;
//   overflow-x: auto;
//   overflow-y: visible;
//   & table {
//     width: 100%;
//     table-layout: fixed;
//     border-collapse: collapse;
//     min-width: var(--minWidth);
//     margin-bottom: 0 !important;
//     & thead {
//       & th {
//         font-weight: bold;
//       }
//     }
//   }
//   & .eixo {
//     z-index: 3 !important;
//   }
//   & th.eixo {
//     width: var(--freezeWidth);
//   }
//   & thead tr:first-child th {
//     position: -webkit-sticky;
//     position: sticky;
//     top: 0;
//     z-index: 2;
//   }
//   & table td:first-child,
//   & table th:first-child {
//     position: -webkit-sticky;
//     position: sticky;
//     left: 0;
//     z-index: 1;
//     background: #fff;
//   }
//   & table th:first-child {
//     width: var(--width);
//     padding-left: 24px;
//   }
//   & thead tr:nth-child(2) th {
//     background-color: #f2f2f2;
//     -webkit-print-color-adjust: exact;
//     position: -webkit-sticky;
//     position: sticky;
//     top: 75px;
//     left: 0;
//     z-index: 2;
//     height: 40px;
//   }
//   & .table-striped tbody > tr:nth-of-type(2n) {
//     background-color: #fff;
//   }
//   & table tr.alternate th,
//   & table tr.alternate td {
//     background-color: #f2f2f2 !important;
//     -webkit-print-color-adjust: exact;
//   }
//   & table {
//     &.overflowing-both,
//     &.overflowing-left {
//       tbody th:first-child {
//         box-shadow: -2px 20px 20px rgba(135, 135, 135, 0.5);
//       }
//     }
//   }
// }
// tr[role="tablist"] {
//   button.btn {
//     text-align: left;
//     box-shadow: none;
//     border-radius: 0;
//   }
//   .b-table-sticky-header {
//     max-height: none;
//   }
//   table {
//     & th:not(:first-child),
//     & td:not(:first-child) {
//       text-align: center;
//       background: #fff;
//     }
//     & th,
//     & td {
//       font-size: 0.8rem !important;
//       padding: 8px 4px !important;
//       & > div {
//         font-size: 13px;
//       }
//     }
//   }
// }

td.plano_selecionado {
  background-color: #f3dc83 !important;
}

td.plano_selecionado2 {
  background-color: #f3dc8388 !important;
}

.table>thead>tr>th,
.table>tbody>tr>th,
.table>tfoot>tr>th,
.table>thead>tr>td,
.table>tbody>tr>td,
.table>tfoot>tr>td {
  padding: 12px;
  vertical-align: middle;
  color: #4d5656 !important;
  font-size: 0.7rem !important;
  padding: 4px 2px !important;
  border-left: none;
}

.table>tbody>tr>td:last-child {
  text-align: center;
}

.textChecked {
  display: none;
}

.custonCheck {
  display: flex;
  justify-content: center;
}

//Table 2

.resumoGeral {
  float: left;
  font-size: 1.1rem;
  font-weight: 400;
  margin: 0;
}

.resumoGeralTH {
  width: 900px !important;
}

.resGeralAling {
  display: flex;
  justify-content: space-between;
}

.alinharValores {
  text-align: center;
}

.bordazIndex {
  border-right: 1px solid #dee2e6 !important;
}

.testando-bg {
  background-color: #f2f2f2;
  color: #4d5656;
  border: none !important;
}

.testando-bg:hover {
  color: #4d5656;
  background-color: #f2f2f2;
}

.testando-bg::before {
  background-color: #f2f2f2;
}

.inputVidas {
  border: 1px solid #eee;
}

.card-header .collapsed>.fa-chevron-up,
.card-header .not-collapsed>.fa-chevron-down {
  display: none;
}

.list-group-item.active {
  z-index: 2;
  color: #fff;
  font-weight: bold;
  background-color: #7dd488;
  border-color: #67ad70;
}

.card-aviso .card-header,
.card-cabecalho .card-header {
  padding: 0.75rem 1.25rem !important;
}

.card-aviso .card-title,
.card-cabecalho .card-title {
  font-size: 0.9rem;
  font-weight: bold !important;
}

.card-aviso p,
.card-cabecalho p {
  font-size: 0.8rem;
}

.card-aviso .card-title,
.card-aviso p {
  color: #b92331;
}

.card-aviso .btn,
.card-cabecalho .btn {
  font-size: 12px !important;
  line-height: 1.5 !important;
  text-transform: lowercase;
}

.break-all {
  word-break: break-all;
}

.b-icon.regioes {
  float: right;
  margin-top: 3px;
  color: rgb(107 107 107);
}

.b-icon.regioes:hover {
  color: #212529;
}

.credenciado_obs {
  max-width: initial;
}

.buttonsContainer div {
  background-color: #41b883;
  width: fit-content;
  display: flex;
  justify-content: center;
  border-radius: 10px;
}

.ViewModeButtons {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin: 0 1rem 1rem;
  padding: 0 .5rem;
  border: none;
  color: #fff;
}

.leftButton {
  width: 7.5rem;
  height: 2rem;
  background: #41b883;
  border: none;
  border-radius: 5px;

  color: #fff;
  font-weight: 100;
  font-size: 1rem;

  transition: ease-in-out 0.3s;
  margin: .3rem;

}

.leftButton:hover {
  background-color: #009b3a;
  scale: 1.02;
}

.leftButtonActive {
  width: 7.5rem;
  height: 2rem;
  background: #fff;
  border: none;
  border-radius: 5px;

  color: #41b883;
  font-weight: 100;
  font-size: 1rem;

  transition: ease-in-out 0.3s;
  margin: .3rem;
}

.LeftButtonActive:hover {
  scale: 1.02;
}



.rightButton {
  width: 2rem;
  height: 2rem;
  background: #41b883;
  border: none;
  border-radius: 5px;

  color: #fff;
  font-weight: 600;
  font-size: 1rem;
  margin: 0.3rem;

  transition: ease-in-out 0.3s;
}

.rightButtonActive {
  width: 2rem;
  height: 2rem;
  background: #fff;
  border: none;
  border-radius: 5px;

  color: #41b883;
  font-weight: 600;
  font-size: 1rem;

  transition: ease-in-out 0.3s;
  margin: .3rem;
}

.rightButton:hover {
  background-color: #009b3a;
  scale: 1.03;
}

@media (max-width: 280px) {
  .ViewModeButtons {
    display: flex;
    flex-direction: column;
  }

  .buttonsContainer div {
    margin: .3rem auto;
  }
}

@media (max-width: 520px) {

  .imprimir {
    display: none;
  }

  .buttonsContainer div {
    display: flex;
    justify-content: space-between;

  }

  .leftButton {
    width: 6.5rem;
    height: 2rem;
    background: #41b883;
    border: none;
    border-radius: 5px;

    color: #fff;
    font-weight: 100;
    font-size: 1rem;

    transition: ease-in-out 0.3s;
    margin: .3rem;

  }

  .leftButton:hover {
    background-color: #009b3a;
    scale: 1.02;
  }

  .leftButtonActive {
    width: 6.5rem;
    height: 2rem;
    background: #fff;
    border: none;
    border-radius: 5px;

    color: #41b883;
    font-weight: 100;
    font-size: 1rem;

    transition: ease-in-out 0.3s;
    margin: .3rem;
  }

  .LeftButtonActive:hover {
    scale: 1.02;
  }



  .rightButton {
    width: 1.8rem;
    height: 2rem;
    background: #41b883;
    border: none;
    border-radius: 5px;

    color: #fff;
    font-weight: 100;
    font-size: 1rem;
    margin: 0.3rem;

    transition: ease-in-out 0.3s;
  }

  .rightButtonActive {
    width: 1.8rem;
    height: 2rem;
    background: #fff;
    border: none;
    border-radius: 5px;

    color: #41b883;
    font-weight: 100;
    font-size: 1rem;

    transition: ease-in-out 0.3s;
    margin: .3rem;
  }
}

.PlanCards {
  width: 100%;
  margin: 0 1rem 1rem 1rem;
  background-color: #fff;
  border-radius: 10px;

  box-shadow: 0 0 1px rgba(0, 0, 0, 0.125),
    0 1px 3px rgba(0, 0, 0, 0.2);
}

.FilterButtons {
  display: flex;
  width: 100%;
  justify-content: flex-end;

  padding: 1rem;
}

.FilterButtons select {
  cursor: pointer;
  height: 2.3rem;
  font-size: 1rem;
  color: #727578;

  border: none;
  padding: 0.2rem;
  margin: 0 .3rem;

  border-radius: 5px;

  transition: 0.2s ease-in-out;
}

.FilterButtons select:hover {
  border: #727578 1px solid;
  scale: 1.03;
}

.FilterButtons select:focus {
  border: #727578 1px solid;
}

.FilterButtons.d-md-block {
  display: flex;
}

.GroupSelection {
  display: flex;
  width: 100%;
  justify-content: center;
  font-size: 17px;
  font-weight: 100;
}

.GroupButtonActive {
  cursor: pointer;
  background-color: #41b883;
  margin: .5rem;
  padding: .2rem .5rem;
  border: none;
  border-radius: 5px;

  font-size: 17px;
  font-weight: 100;
  color: #FFF;

  transition: ease-in-out 0.3s;
}

.GroupButtonDeactive {
  background-color: transparent;
  margin: .5rem;
  padding: .2rem .5rem;
  border: none;
  border-radius: 5px;

  font-size: 17px;
  font-weight: 100;
  color: #727578;

  transition: ease-in-out 0.3s;
}

.CardsContainer {
  margin: 0 auto;
  max-width: 1315px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(310px, 1fr));
  grid-auto-rows: auto;
  gap: 20px;
  padding: 30px 0;
}

.compareStripBG {
  background-color: #41b88348;
  position: fixed;
  width: 100%;
  height: 5rem;

  z-index: 999;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 20px;


  bottom: 0;
  left: 0;
  right: 0;
}

.compareStripBG div {
  cursor: pointer;
  transition: ease-in-out 0.1s;
}

.compareButton {
  background-color: #41b883;
  border: none;
  border-radius: .25rem;
  color: #fff;

  padding: .375rem 0.75rem;

  font-size: 1.3rem;
  font-weight: 400;

  display: flex;
  justify-content: space-around;
  text-align: center;
  align-items: center;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.125), 0 3px 6px rgba(0, 0, 0, 0.2);

  margin-right: .25rem;
}

.cleanButton {
  color: #1f2d3d;
  background-color: #ffc107;
  border-color: #ffc107;
  box-shadow: none;
  border: none;
  border-radius: .25rem;

  padding: .375rem 0.75rem;

  font-size: 1.3rem;
  display: flex;
  justify-content: space-around;
  text-align: center;
  align-items: center;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.125), 0 3px 6px rgba(0, 0, 0, 0.2);
}

.cleanButton:hover {
  background-color: #ffc107b4;
  border-color: #ffc107b4;
}

.planNumber {
  height: 1.3rem;
  width: 1.3rem;

  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 50%;
  background-color: #dc3545;
  color: #fff;
  font-size: 1.1rem;

  position: absolute;

  bottom: 3.2rem;
  margin-right: 15.5rem;

  z-index: 9999;

}

@media (max-width: 768px) {
  .compareStripBG {

    width: 100%;


  }
}

@media (max-width: 550px) {
  .FilterButtons {
    display: flex;
    flex-direction: column;
  }
}

.resultContainer {
  width: 100%;
  margin: 0 1rem 1rem 1rem;
  background-color: #fff;
  border-radius: 10px;
}

.bounce-enter-active {
  animation: bounce-in 0.5s;
}

.bounce-leave-active {
  animation: bounce-out 0.5s;
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }

  70% {
    transform: scale(1.2);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes bounce-out {
  0% {
    transform: scale(1);
  }

  30% {
    transform: scale(1.2);
  }

  100% {
    transform: scale(0);
  }
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active {
  transition: opacity 0.5s;
}

.fade-leave-active {
  position: absolute;
  transition: opacity 0.5s;
}

.fade-leave-active.box {
  opacity: 1;
}

.table-container {
  overflow-x: auto;
}

.ComparativeTable {
  width: 100%;

}

.ComparativeTable th {
  width: 15rem;
  font-size: 20px;
  padding-left: 1rem;
  font-weight: 500;

}

.ComparativeTable td {
  min-width: 20rem;
  text-align: center;
  font-size: 1.05rem;
}

.ComparativeTable th:nth-child(n+3) {
  background-color: #f2f2f2;
}

.ComparativeTable tr:nth-child(even) {
  background-color: #f9f9f9;
}

.ComparativeTable td,
th {
  padding: .75rem;
  vertical-align: top;
  height: 50px;
  line-height: 1.5;
  color: #575c6a;
}

.ComparativeTable button {
  color: #007bff;
  background: transparent;
  border: none;
}

.faixaCor {
  border-bottom: 10px solid;
}

.CleanComparativeTable {
  margin: 1rem;
  width: 9.5rem;
  height: 2rem;
  background: #41b883;
  border: none;
  border-radius: 5px;

  color: #fff;
  font-weight: 600;
  font-size: 1rem;

  transition: ease-in-out 0.3s;

  box-shadow: 0 0 2px rgba(0, 0, 0, 0.125), 0 3px 6px rgba(0, 0, 0, 0.2);
}
</style>
